import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n        Complete Amendment\n      ")
], -1);
const _hoisted_3 = { class: "p-5 my-8 bg-slate-200 rounded-3xl" };
const _hoisted_4 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "p-8 space-y-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", null, "\n            You will not be able to change this request once it has been\n            submitted. Are you sure you would like to complete this amendment\n            request?\n          ", -1);
const _hoisted_7 = {
    key: 0,
    class: "rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-700"
};
const _hoisted_8 = { class: "mt-4 flex justify-end" };
const _hoisted_9 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SendAmendLetterUpload = _resolveComponent("SendAmendLetterUpload");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    (_ctx.loadError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.loadError), 1))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.docId && _ctx.docOwner && !_ctx.loadError)
                        ? (_openBlock(), _createBlock(_component_SendAmendLetterUpload, {
                            key: 1,
                            "doc-id": _ctx.docId,
                            "doc-owner": _ctx.docOwner,
                            "short-id": _ctx.shortId,
                            "recipient-email": _ctx.recipientEmail,
                            "hiring-manager-name": _ctx.hiringManagerName,
                            "employee-full-name": _ctx.employeeFullName,
                            "administrator-name": _ctx.administratorName,
                            "show-send-button": false,
                            onAttachmentChange: _ctx.handleAttachmentChange
                        }, null, 8, ["doc-id", "doc-owner", "short-id", "recipient-email", "hiring-manager-name", "employee-full-name", "administrator-name", "onAttachmentChange"]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                            disabled: _ctx.completing || !!_ctx.loadError,
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleCompleteUser && _ctx.handleCompleteUser(...args)))
                        }, _toDisplayString(_ctx.completing ? 'Completing…' : 'Complete'), 9, _hoisted_9)
                    ])
                ])
            ])
        ])
    ]));
}
